import * as React from 'react';
import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { TopMenu } from '@/components/TopMenu';
import { CircularProgress } from '@mui/material';
import { thunkToAction } from 'typescript-fsa-redux-thunk';

import { authFetchCurrent, authIsAuthorizedSelector } from '@redux';

import { Login } from '@containers/Login';

import { AlertsProvider } from '@components/Alerts';

import { Breadcrumbs } from '@ui';

import { IAppProps } from './types';

import s from './App.scss';

export const App = (props: IAppProps) => {
	const { Router } = props;
	const dispatch = useDispatch();
	const isAuthorized = useSelector(authIsAuthorizedSelector);
	const [isChecking, setIsChecking] = useState(true);

	useEffect(
		() => {
			const checkAuth = async () => {
				try {
					await dispatch(thunkToAction(authFetchCurrent.action)());
				} catch {
					// Не авторизован — покажем экран входа
				} finally {
					setIsChecking(false);
				}
			};

			void checkAuth();
		},
		[],
	);

	if (isChecking) {
		return <CircularProgress className={s.loading}/>;
	}

	if (!isAuthorized) {
		return (
			<AlertsProvider>
				<Login/>
			</AlertsProvider>
		);
	}

	return (
		<AlertsProvider>
			<TopMenu/>

			<div className={s.content}>
				<Breadcrumbs/>
				<Router.Pages />
			</div>
		</AlertsProvider>
	);
};
